function getExtGcd(a, b) {
    let x, y;

    if (a == 0) {
        x = 0;
        y = 1;
        return { b, x, y };
    }

    const gcd = getExtGcd(b % a, a);

    x = gcd.y - Math.floor(b / a) * gcd.x;
    y = gcd.x;
    return { gcd: gcd.b, x, y };
}

function getMod(n, b) {
    return n >= 0 ? n % b : (Math.floor(Math.abs(n) / b) + 1) * b + n;
}

function getGcd(a, b) {
    return b ? getGcd(b, a % b) : a;
}

class Ring {
    constructor(props) {
        this._elements = (props && props.elements) || [];
        this._ringPower = this._elements.length;
        this._step = (props && props.step) || 1;
        this.currentIndex = (props && props.currentIndex) || 0;

        if (this._ringPower) {
            this.currentElement = this._elements[this.currentIndex];
        }
    }

    set elements(val) {
        this._elements = val;
        this._ringPower = this._elements.length;
        this.currentIndex = 0;
        this.updateCurrent(this.currentIndex);
    }

    set step(val) {
        this._step = val;
    }

    get isLast() {
        return this._ringPower === this.currentIndex + 1;
    }

    get isFirst() {
        return this._ringPower === 1;
    }

    add(val) {
        this.updateCurrent(this.currentIndex + val);
    }

    mult(val) {
        this.updateCurrent(this.currentIndex * val);
    }

    div(val) {
        const { x } = getExtGcd(val, this._ringPower);

        if (getGcd(val, this._ringPower) === 1) {
            this.mult(getMod(x, this._ringPower));
        }
    }

    next() {
        this.add(this._step);
    }

    previous() {
        this.add(-this._step);
    }

    updateCurrent(index) {
        this.currentIndex = getMod(index, this._ringPower);
        this.currentElement = this._elements[this.currentIndex];
    }
}

export default Ring;
